const constant = {
  // LocalStorage Keys
  authToken: "auth-token", // Token key for authentication
  currentUser: "current-user", // User details
  userRoleKey: "user-role", // User role key
  appSettings: "app-settings", // Application settings

  // API URLs
  // api: "http://localhost:8003/api/",
  // url: "http://localhost:8003/",

  // Uncomment the relevant API URLs for production
  api: "https://api6.peascom.ma/api/",
  url: "https://api6.peascom.ma/",


  SupportApi: "https://api.peascom.ma/api/",
  SupportUrl: "https://api.peascom.ma/",
};

export default constant;
